/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Link, SimpleGrid } from '@chakra-ui/react';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { refineUrlDomain } from '@components/Utility/utils';

/* Styles */
/* Services */

/**
 * Renders Project Samskriti Card Component
 * @param {Object} sectionContent - Data of Section from api
 * @param {string} region - Region of the Section
 * @param {string} lang - Language of the Section
 * @returns {ReactElement} - Project Samskriti Card
 */

const SamskritiCardColumn = ({ section, region, lang }) => {
  return (
    <SimpleGrid
      spacing={'30px'}
      mt="20px"
      marginBottom="20px"
      columns={{ lg: '3', md: '2', sm: '1', base: '1' }}
    >
      {section.cards.map((card, index) => {
        return (
          <Box
            key={nanoid(4)}
            float="left"
            h={'100%'}
            // width="calc((100% - 60px) / 3)"
            width={'100%'}
            maxW={{ base: '312px', sm: '328px', md: '370px' }}
            m="0 auto"
            // marginRight="30px"
            boxShadow="rgba(0, 0, 0, 0.07) 0px 100px 80px, rgba(0, 0, 0, 0.043) 0px 22.3363px 17.869px, rgba(0, 0, 0, 0.035) 0px 12.5216px 10.0172px"
            marginBottom="20px"
          >
            <Box float="left" w="100%" className="Img-block">
              <Box float="left" w="100%">
                <LazyLoadImageComponent
                  float="left"
                  w="100%"
                  height="225px"
                  objectFit="cover"
                  objectPosition="center center"
                  src={card.thumbnail.url}
                  alt={card.thumbnail.alt}
                  title={card.thumbnail.title}
                />
              </Box>
            </Box>
            <Box
              className="content"
              float="left"
              w="100%"
              background="rgb(255, 255, 255)"
              position="relative"
            >
              <Box
                as="h1"
                float="left"
                width="calc(100% + 1px)"
                height="70px"
                display="flex"
                justifyContent="center"
                flexDirection="column"
                fontFamily="FedraSansStd-A-medium"
                fontSize="20px"
                lineHeight="1.08"
                textAlign="left"
                color="rgb(255, 255, 255);"
                marginTop="-50px"
                px="20px"
                paddingTop="10px"
                background="rgb(94, 8, 10)"
                clipPath="polygon(0px 0px, 100% 25%, 100% 100%, 0% 100%)"
              >
                {card.title}
              </Box>
              <Box float="left" width="70%" padding="17px">
                <Box
                  float="left"
                  width="100%"
                  fontFamily="'FedraSansStd-book', sans-serif"
                  fontSize="14px"
                  lineHeight="1.25"
                  textAlign="left"
                  color="rgb(40, 35, 30)"
                  marginBottom="5px"
                >
                  <StructuredTextParser
                    str={render(card.description)}
                    region={region}
                    lang={lang}
                  />
                </Box>
                <Box
                  float="left"
                  width="100%"
                  fontFamily="'FedraSansStd-book', sans-serif"
                  fontSize="16px"
                  lineHeight="1.15"
                  textAlign="left"
                  color="#28231E"
                  fontWeight="600"
                >
                  {' '}
                  {card.sessions} &nbsp;
                </Box>
              </Box>
              {card?.buttonLink && (
                <Box padding={'17px'}>
                  <NextLink
                    href={refineUrlDomain(card?.buttonLink, region, lang)}
                    passHref
                    legacyBehavior>
                    <Link
                      float="left"
                      w="100%"
                      height="46px"
                      fontFamily="FedraSansStd-book"
                      fontSize="16px"
                      textAlign="center"
                      lineHeight="46px"
                      color="rgb(255, 255, 255)"
                      background="rgb(175, 31, 34)"
                      borderRadius="4px"
                      _hover={{
                        textDecoration: 'none',
                        bg: 'blue.50',
                      }}
                    >
                      Learn More
                    </Link>
                  </NextLink>
                  {/* <Button
                  float="left"
                  w="100%"
                  height="46px"
                  fontFamily="FedraSansStd-book"
                  fontSize="16px"
                  textAlign="center"
                  lineHeight="46px"
                  color="rgb(255, 255, 255)"
                  background="rgb(175, 31, 34)"
                  borderRadius="4px"
                >
                </Button> */}
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </SimpleGrid>
  );
};

export default SamskritiCardColumn;
